/**
 * Expands and collapses the overflow items within a personalized product section.
 * A landing page renders one section per recommendation set, so the handler is
 * delegated and scoped to the closest section rather than bound to a single id.
 * @module productSectionViewMore
 */

import $ from 'jquery';

export const CLICK_EVENT = 'click';
export const ACTIVE_CLASS = 'is-active';

export const SELECTORS = {
  section: '.product-sections',
  button: '.js-productsection-viewmore',
  items: '.js-viewmore-items'
};

const LABEL_ATTRIBUTES = {
  expand: 'data-label-expand',
  collapse: 'data-label-collapse'
};

/**
 * Binds the view more/less toggle for every product section under a container.
 * @param {string|HTMLElement} [container] - Scope to delegate from, defaults to
 * the document so sections added after init are still covered
 */
export default function init(container) {
  $(container || document).on(CLICK_EVENT, SELECTORS.button, buttonClickHandler);
}

/**
 * Toggles the overflow items belonging to the clicked button's section.
 * @param {jQuery.Event} evt - A jQuery event
 */
function buttonClickHandler(evt) {
  evt.preventDefault();

  var $button = $(this);
  var $items = $button.closest(SELECTORS.section).find(SELECTORS.items);

  if (!$items.length) {
    return;
  }

  // The class is the source of truth for the current state -- reading :visible
  // is unreliable while a previous slide is still animating.
  var isExpanded = $button.hasClass(ACTIVE_CLASS);

  $button.toggleClass(ACTIVE_CLASS, !isExpanded);
  $button.attr('aria-expanded', !isExpanded);
  $button.text(isExpanded
    ? $button.attr(LABEL_ATTRIBUTES.expand)
    : $button.attr(LABEL_ATTRIBUTES.collapse));

  $items.stop(true, true).slideToggle();
}



// WEBPACK FOOTER //
// ./src/scripts/modules/product-section-view-more.js